/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResult } from '../models';
// @ts-ignore
import type { GetGraphVisualisationDataForGroup200Response } from '../models';
/**
 * NexusApi - axios parameter creator
 */
export const NexusApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary nexusGraph
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraphVisualisationDataForGroup: async (groupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('getGraphVisualisationDataForGroup', 'groupId', groupId)
            const localVarPath = `/api/nora/nexus/graph/group/{groupId}`
                .replace('{groupId}', encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary nexusGraph
         * @param {string} userId 
         * @param {string} [membershipType] Filter by membership type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraphVisualisationDataForUser: async (userId: string, membershipType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getGraphVisualisationDataForUser', 'userId', userId)
            const localVarPath = `/api/nora/nexus/graph/user/{userId}`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (membershipType !== undefined) {
                localVarQueryParameter['membershipType'] = membershipType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolvePerformance: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/nexus/resolve-performance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NexusApi - functional programming interface
 */
export const NexusApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NexusApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary nexusGraph
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGraphVisualisationDataForGroup(groupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGraphVisualisationDataForGroup200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGraphVisualisationDataForGroup(groupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusApi.getGraphVisualisationDataForGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary nexusGraph
         * @param {string} userId 
         * @param {string} [membershipType] Filter by membership type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGraphVisualisationDataForUser(userId: string, membershipType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGraphVisualisationDataForGroup200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGraphVisualisationDataForUser(userId, membershipType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusApi.getGraphVisualisationDataForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolvePerformance(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolvePerformance(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusApi.resolvePerformance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NexusApi - factory interface
 */
export const NexusApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NexusApiFp(configuration)
    return {
        /**
         * 
         * @summary nexusGraph
         * @param {NexusApiGetGraphVisualisationDataForGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraphVisualisationDataForGroup(requestParameters: NexusApiGetGraphVisualisationDataForGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetGraphVisualisationDataForGroup200Response> {
            return localVarFp.getGraphVisualisationDataForGroup(requestParameters.groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary nexusGraph
         * @param {NexusApiGetGraphVisualisationDataForUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraphVisualisationDataForUser(requestParameters: NexusApiGetGraphVisualisationDataForUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetGraphVisualisationDataForGroup200Response> {
            return localVarFp.getGraphVisualisationDataForUser(requestParameters.userId, requestParameters.membershipType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolvePerformance(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resolvePerformance(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getGraphVisualisationDataForGroup operation in NexusApi.
 */
export interface NexusApiGetGraphVisualisationDataForGroupRequest {
    readonly groupId: string
}

/**
 * Request parameters for getGraphVisualisationDataForUser operation in NexusApi.
 */
export interface NexusApiGetGraphVisualisationDataForUserRequest {
    readonly userId: string

    /**
     * Filter by membership type
     */
    readonly membershipType?: string
}

/**
 * NexusApi - object-oriented interface
 */
export class NexusApi extends BaseAPI {
    /**
     * 
     * @summary nexusGraph
     * @param {NexusApiGetGraphVisualisationDataForGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getGraphVisualisationDataForGroup(requestParameters: NexusApiGetGraphVisualisationDataForGroupRequest, options?: RawAxiosRequestConfig) {
        return NexusApiFp(this.configuration).getGraphVisualisationDataForGroup(requestParameters.groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary nexusGraph
     * @param {NexusApiGetGraphVisualisationDataForUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getGraphVisualisationDataForUser(requestParameters: NexusApiGetGraphVisualisationDataForUserRequest, options?: RawAxiosRequestConfig) {
        return NexusApiFp(this.configuration).getGraphVisualisationDataForUser(requestParameters.userId, requestParameters.membershipType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resolvePerformance(options?: RawAxiosRequestConfig) {
        return NexusApiFp(this.configuration).resolvePerformance(options).then((request) => request(this.axios, this.basePath));
    }
}

